export function composerCanSend(text) {
  return (text || '').trim().length > 0
}

export function enterToSend(event) {
  if (event.key === 'Enter' && !event.shiftKey && !event.metaKey && !event.ctrlKey) return 'send'
  return 'newline'
}
